<i18n>
    {
        "cn": {
            back_to_top: "返回顶部",
        },
        "en": {
            back_to_top: "Back Top",
        },
    }
</i18n>
<script>
export default {
    name: "btnBackTop",
    data() {
        return {
            isShowBackBtn: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {},
    methods: {
        handleScroll() { 
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 600) { 
                this.isShowBackBtn = true;
            } else {
                this.isShowBackBtn = false;
            }
        },
        backTop() { 
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            })
        },
    },
};
</script>

<template>
    <div class="btn_back_top_wrap">
        <div class="btn_back_top flex flex_column align_center justify_center" v-if="isShowBackBtn" @click="backTop">
            <img :src="require('@/assets/images/icon_back_top.png')" alt="" class="icon"/>
            <p class="text">{{ $t('back_to_top') }}</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.btn_back_top_wrap{
    position: absolute;
    top: 0;
    right: -1rem;
    height: calc(100% - .5rem);
    // height: 100%;
    z-index: 1;
    @media only screen and (max-width: 750px) {
        right: auto;
        left: .3rem;
        height: calc(100% - .7rem);
    }
}
.btn_back_top{
    position: sticky;
    font-size: .16rem;
    width: .7rem;
    height: .7rem;
    cursor: pointer;
    left: 0;
    top: 90%;
    @media only screen and (max-width: 750px) {
        border-radius: 50%;
        border: 1px solid #999;
        background: #fff;
        .icon{
            width: 60%;
        }
        .text{
            display: none;
        }
    }
}
</style>